
import React from 'react';
import Category from './Category';
import DashboardLayout from '../../../components/Shop/RestaurantLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, intl, params }) {
  const title = intl.formatMessage(messages.manageMenu);
  let isRestaurantAuthenticated = store.getState().runtime.isRestaurantAuthenticated;

  if (!isRestaurantAuthenticated) {
    return { redirect: '/restaurant' };
  };

  return {
    title,
    component: (
      <DashboardLayout>
        <Category title={title} />
      </DashboardLayout>
    ),
  };
}

export default action;
